import React, { useMemo } from 'react';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
// @ts-ignore
import styles from './BMIMeasurementHistoryItemHeader.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	date: string;
	bmi: number;
}

const BMIMeasurementHistoryItemHeader: React.FC<Props> = ({ date, bmi }) => {
	const { t } = useTranslation();

	const info = useMemo(() => {
		if (bmi < 18.5) {
			return {
				title: 'component.BMIMeasurementHistoryItemHeader.underweight.title',
				specification:
					'component.BMIMeasurementHistoryItemHeader.underweight.specification',
				color: '#0f8bd2',
				image: 'http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-blue.png',
			};
		} else if (bmi < 24.9) {
			return {
				title: 'component.BMIMeasurementHistoryItemHeader.normalWeight.title',
				specification:
					'component.BMIMeasurementHistoryItemHeader.normalWeight.specification',
				color: '#2bb188',
				image:
					'http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-green.png',
			};
		} else if (bmi < 29.9) {
			return {
				title: 'component.BMIMeasurementHistoryItemHeader.overweight.title',
				specification:
					'component.BMIMeasurementHistoryItemHeader.overweight.specification',
				color: '#efcf4a',
				image:
					'http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-yellow.png',
			};
		} else if (bmi < 34.9) {
			return {
				title: 'component.BMIMeasurementHistoryItemHeader.obesity.title',
				specification:
					'component.BMIMeasurementHistoryItemHeader.obesity.specification',
				color: '#ff8506',
				image:
					'http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-orange.png',
			};
		} else {
			return {
				title: 'component.BMIMeasurementHistoryItemHeader.extremeObesity.title',
				specification:
					'component.BMIMeasurementHistoryItemHeader.extremeObesity.specification',
				color: '#d20f0f',
				image: 'http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-red.png',
			};
		}
	}, [bmi]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.image}>
				<img src={info.image} />
			</div>
			<div>
				<div className={styles.date}>
					<FormattedMomentDate date={date} format={DateFormat.DATE_TIME} />
				</div>
				<div className={styles.title}>BMI - {bmi}</div>
				<div className={styles.label} style={{ color: info.color }}>
					<span>{t(info.title)}</span> {t(info.specification)}
				</div>
			</div>
		</div>
	);
};

export default BMIMeasurementHistoryItemHeader;
